/**
 * Temporary stub for additional fee charge types until ecommerce exposes
 * GET /logistics/v1/crossDockPurchaseOrders/additionalFeeChargeTypes
 * (see docs/logistics/cross-dock-fees-pr-plan.md).
 *
 * Single frontend copy of values — mirrors CrossDockPurchaseOrderAdditionalFeeTypeEnum.
 */
export const CROSS_DOCK_PURCHASE_ORDER_ADDITIONAL_FEE_TYPES_STUB = [
    { chargeType: 'SERVICE_FEE', label: 'Service Fee', required: true },
    { chargeType: 'COLD_WRAP', label: 'Cold Wrap', required: false },
    { chargeType: 'INSPECTION_FEE', label: 'Inspection Fee', required: false },
    { chargeType: 'PALLET_FEE', label: 'Pallet Fee', required: false },
    { chargeType: 'RESTACK', label: 'Restack', required: false },
    { chargeType: 'RESHUFFLING', label: 'Reshuffling', required: false },
    { chargeType: 'SHIPPING_FEE', label: 'Shipping Fee', required: false },
];

/**
 * @returns {Promise<{ status: boolean, data?: { chargeTypes: Array<{ chargeType: string, label: string, required: boolean }> }, msg?: string }>}
 */
export async function fetchCrossDockPurchaseOrderAdditionalFeeTypes() {
    // TODO(ecommerce): replace stub with mmFetchWithResponse(
    //   'api/logistics/v1/crossDockPurchaseOrders/additionalFeeChargeTypes',
    // );
    return {
        status: true,
        data: {
            chargeTypes: CROSS_DOCK_PURCHASE_ORDER_ADDITIONAL_FEE_TYPES_STUB,
        },
    };
}
